<template>
  <span
    class="subprogram-nba-summary-start-playoffs-button"
  >
    <el-button
      type="primary"
      @click="handleClick"
    >
      <app-i18n
        code="entities.subprogram.nba.startPlayoffs.button"
      />
    </el-button>

    <!-- Alerts -->
    <custom-alert
      v-if="currentAlert"
      :visible="true"
      :type="currentAlert.type"
      :title="currentAlert.title"
      :description="currentAlert.description"
      :confirm-text="currentAlert.confirmText"
      :on-confirm-fn="currentAlert.onConfirmFn"
      :on-close-fn="currentAlert.onCloseFn"
      :visible-on-confirm="true"
      :lock-close="isCloseable(currentAlert.type)"
      :closeable="isCloseable(currentAlert.type)"
    />
  </span>
</template>

<script>
import { i18n } from '@shared/i18n'
import { mapActions } from 'vuex'

export default {
  name: 'AppSubprogramNbaSummaryStartPlayoffsButton',

  props: {
    propertyId: {
      type: String,
      required: true,
    },
    subpropertyId: {
      type: String,
      required: true,
    },
    programId: {
      type: String,
      required: true,
    },
    subprogramId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      currentAlert: null,
      unplayedGames: null,
    }
  },

  computed: {
    alerts() {
      return {
        step1: {
          type: 'info',
          title: i18n('entities.subprogram.nba.startPlayoffs.alerts.step1.title'),
          description: i18n('entities.subprogram.nba.startPlayoffs.alerts.step1.description'),
          confirmText: i18n('common.continue'),
          onConfirmFn: () => this.checkUnplayedGamesAndNext(),
          onCloseFn: () => { this.currentAlert = null },
        },
        step2: {
          type: 'loading',
        },
        step3: {
          type: 'loading',
          title: i18n('entities.subprogram.nba.startPlayoffs.alerts.step2.title'),
        },
        step4: {
          type: 'success',
          title: i18n('entities.subprogram.nba.startPlayoffs.alerts.step3.title'),
          description: i18n('entities.subprogram.nba.startPlayoffs.alerts.step3.description'),
          confirmText: i18n('common.continue'),
          onConfirmFn: () => this.reloadDataAndClose(),
        },
        warning: {
          type: 'warning',
          title: i18n('entities.subprogram.nba.startPlayoffs.alerts.warning.title', this.unplayedGames),
          description: i18n('entities.subprogram.nba.startPlayoffs.alerts.warning.description'),
          confirmText: i18n('entities.subprogram.nba.startPlayoffs.alerts.warning.button'),
          onConfirmFn: () => this.gotoUnplayedGames(), // this.gotoStep3() to start playoffs with unplayed games
          onCloseFn: () => { this.currentAlert = null },
        },
      }
    },
  },

  methods: {
    i18n,
    ...mapActions({
      getGamesStats: 'subprogram/nba/getGamesStats',
      doStartPlayoffs: 'subprogram/nba/summary/doStartPlayoffs',
      doInitParams: 'subprogram/nba/doInitParams',
      setActiveTabIndex: 'layout/headerTabs/setActiveTabIndex',
    }),
    handleClick() {
      this.currentAlert = this.alerts.step1
    },
    isCloseable(type) {
      return type === 'info' || type === 'warning'
    },
    async checkUnplayedGamesAndNext() {
      this.currentAlert = this.alerts.step2
      const { unplayedCount } = await this.getGamesStats({
        subpropertyId: this.subpropertyId,
        subprogramId: this.subprogramId,
      })
      this.unplayedGames = unplayedCount
      if (this.unplayedGames === 0) this.gotoStep3()
      else this.currentAlert = this.alerts.warning
    },
    async gotoStep3() {
      this.currentAlert = this.alerts.step3
      const success = await this.doStartPlayoffs({
        subpropertyId: this.subpropertyId,
        programId: this.programId,
        subprogramId: this.subprogramId,
      })
      if (success) this.currentAlert = this.alerts.step4
      else this.currentAlert = null
    },
    async reloadDataAndClose() {
      await this.doInitParams({
        subpropertyId: this.subpropertyId,
        programId: this.programId,
        subprogramId: this.subprogramId,
      })
      this.setActiveTabIndex(1)
      this.$router.push({
        name: 'SubprogramNba',
        params: { programId: this.programId, subprogramId: this.subprogramId, tabName: 'schedule' },
        query: { type: 'playoffs' },
      })
      this.currentAlert = null
    },

    gotoUnplayedGames() {
      this.setActiveTabIndex(1)
      this.$router.push({
        name: 'SubprogramNba',
        params: { programId: this.programId, subprogramId: this.subprogramId, tabName: 'schedule' },
        query: { status: 'toPlay' },
      })
    },
  },
}
</script>
